import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../../PageTemplate/ListFormTemplate";
//import axios from 'axios';
import { config } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";
import useFleetLocationsLogic from "./useFleetLocationsLogic";

const columns = [
  //{ field: 'id', label: 'ID', allowSorting: false },
  { field: "name", label: "Name", allowSorting: true },
  {
    field: "branch",
    label: "Branch",
    allowSorting: true,
    subvalue: "Name",
    showInFilter: true,
  },
  { field: "city", label: "City", allowSorting: false, showInFilter: true },
  { field: "phone_number", label: "Phone Number", allowSorting: false },
];

const FleetLocationsPage = () => {
  const { apiRoute, addRoles, editRoles, deleteRoles, initFields } =
    useFleetLocationsLogic();
  const [fields, setfields] = useState(initFields);

  const loadOptions = async (branchId) => {
    try {
      // Replace with your API endpoint to fetch the data

      const temp = [...initFields];
      await fetchDataAndMapToField(config, "branches", "branch", temp, "Name");
      setfields(temp);
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  useEffect(() => {
    loadOptions();
  }, []);

  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to the Fleet locations." />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        tableNameInDb={"fleet_location"}
        apiRoute={apiRoute}
        columns={columns}
        fields={fields}
        bringFormData={loadOptions}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
      />
    </div>
  );
};

export default FleetLocationsPage;
